import React from "react";
import './Loader.css';

function Loader2() {
    return (
        <div className="overlay">
            <div className="paceloader">
                <div className="ring"></div>
                <div className="ring"></div>
                <div className="ring"></div>
                <div>
                    <img src={require ('../../../assets/images/logo_icon.png')} width={"60px"} height={"60px"} alt="pace-logo" style={{ height: "auto" }} />
                </div>
            </div>
        </div>
    );
}

export default Loader2;
